export const LOADING_NOTIFICATION_HISTORY = "LOADING_NOTIFICATION_HISTORY";
export const SAVE_LOADING_NOTIFICATION_HISTORY = "SAVE_LOADING_NOTIFICATION_HISTORY";
export const GET_NOTIFICATION_HISTORY = "GET_NOTIFICATION_HISTORY";
export const FORM_FAIL = "FORM_FAIL";
export const NOTIFICATION_HISTORY_FAIL = "NOTIFICATION_HISTORY_FAIL";
export const LOADING_NOTIFICATION_HISTORY_BY_ID = "LOADING_NOTIFICATION_HISTORY_BY_ID";
export const GET_NOTIFICATION_HISTORY_BY_ID = "GET_NOTIFICATION_HISTORY_BY_ID";